import * as E from "../../either";
import { fromValidate } from "../validated";
export const empty = () => fromValidate(() => E.right(void 0));

